import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import UA from '@alicloud/ua';
import getDefaultParamsPage from './get-default-params-page';
import getDefaultParamsUser from './get-default-params-user';
export default function getDefaultParams() {
  return _objectSpread(_objectSpread({
    UA: navigator.userAgent,
    OS: UA.OS,
    OS_VERSION: UA.OS_VERSION,
    BROWSER: UA.BROWSER,
    BROWSER_VERSION: UA.BROWSER_VERSION
  }, getDefaultParamsPage()), getDefaultParamsUser());
}
//# sourceMappingURL=get-default-params.js.map